import { ConfigScreen } from "features/config";
import { DevicesScreen } from "features/devices/DevicesScreen";
import { DocumentationScreen } from "features/documentation/DocumentationScreen";
import { StartGameScreen } from "features/game-session/StartGameScreen";
import { HomeScreen } from "features/home";
import { LinkScreen } from "features/links";
import { MatchesScreen } from "features/matches/MatchesScreen";
import { Sessions } from "features/sessions/Sessions";
import { UserScreen } from "features/users";
import { CreateUserForm } from "features/users/add";
import { EditUserForm } from "features/users/edit";
import { UserRole } from "interfaces/User";
import { Redirect, Route, Switch } from "react-router-dom";

import { NAVIGATOR } from "../index";
import PrivateRoute from "../PrivateRoute";

export const adminRoutes = [
  { path: NAVIGATOR.home, component: HomeScreen },
  { path: NAVIGATOR.sessions, component: Sessions },
  { path: `${NAVIGATOR.sessions}/:sessionId`, component: StartGameScreen },
  { path: NAVIGATOR.devices, component: DevicesScreen },
  { path: NAVIGATOR.matches, component: MatchesScreen },
  { path: NAVIGATOR.configs, component: ConfigScreen },
  { path: NAVIGATOR.link, component: LinkScreen },
  { path: NAVIGATOR.documentation, component: DocumentationScreen },
  //TODO: Check these routes/screens
  //   path: `${NAVIGATOR.registerPlayer}/:containerNumber`,
  //   component: TabletScreen,
  // },
];

export const superAdminRoutes = [
  { path: NAVIGATOR.users, component: UserScreen },
  { path: NAVIGATOR.createUser, component: CreateUserForm },
  { path: `${NAVIGATOR.editUser}/:id`, component: EditUserForm },
];

export const MainNavigator = () => {
  return (
    <Switch>
      {adminRoutes.map((route, index) => (
        <PrivateRoute
          key={index}
          exact
          role={UserRole.admin}
          path={route.path}
          component={route.component}
        />
      ))}
      {superAdminRoutes.map((route, index) => (
        <PrivateRoute
          key={index}
          exact
          role={UserRole.superAdmin}
          path={route.path}
          component={route.component}
        />
      ))}
      <Route path="*">
        <Redirect to={NAVIGATOR.home} />
      </Route>
    </Switch>
  );
};
